export function financialSingleSignOn(callbackSuccess, callbackError) {
  return {
    type: "FINANCIAL_SINGLE_SIGN_ON",
    payload: {
      callbackSuccess,
      callbackError,
    },
  };
}
